import * as Sentry from '@sentry/vue'

// Code from https://www.lichter.io/articles/nuxt3-sentry-recipe/
export default defineNuxtPlugin((nuxtApp) => {
    const router = useRouter()
    const { public: { sentry } } = useRuntimeConfig()

    if (!sentry.dsn) {
        return
    }

    Sentry.init({
        app: nuxtApp.vueApp,
        dsn: sentry.dsn,
        environment: sentry.environment,
        ignoreErrors:
        [
          // In-app browsers (e.g. in-app facebook browser)
          'window.webkit.messageHandlers',
          // Safari bug (bugs.webkit.org/show_bug.cgi?id=255764)
          'Object.prototype.hasOwnProperty.call(e,"telephone")',
          // Cookiebot bugs (https://github.com/getsentry/sentry-javascript/issues/16850#issuecomment-3051941650)
          `Cannot read properties of undefined (reading 'bind')`,
          'updateVisibleFocusableElements'
        ],
        denyUrls:
        [
          // Cookiebot bugs (https://github.com/getsentry/sentry-javascript/issues/16850#issuecomment-3051941650)
          'cookiebot'
        ],
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
            // https://docs.sentry.io/platforms/javascript/guides/nuxt/configuration/filtering/#using-thirdpartyerrorfilterintegration
            Sentry.thirdPartyErrorFilterIntegration({
                behaviour: "apply-tag-if-exclusively-contains-third-party-frames",
                // Specify the application keys that you specified in the Sentry bundler plugin
                filterKeys: ["bokabord.se"],
            }),
        ],

        tracesSampleRate: sentry.tracesSampleRate,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'https://bokabord.se'],

        replaysSessionSampleRate: sentry.replaysSessionSampleRate,
        replaysOnErrorSampleRate: sentry.replaysOnErrorSampleRate
    })
})
